import absoluteUrl from 'next-absolute-url'

import Vouchers from 'containers/Vouchers'

import Layout from 'components/Layout'
import MetaTags from 'components/MetaTags'

import { getVoucherListApi } from 'services/promotion'

export default function Index({ canonical, vouchers }) {
  const metaTitle = '24 FIX | Vouchers'
  const metaDescription = '24 FIX | Vouchers'

  return (
    <>
      <MetaTags title={metaTitle} description={metaDescription} pathUrl={canonical} />

      <Layout>
        <Vouchers vouchers={vouchers} />
      </Layout>
    </>
  )
}

export async function getServerSideProps(context) {
  const { req, res } = context
  const { origin } = absoluteUrl(req)

  const vouchers = await getVoucherListApi().then(res => res.data.data)

  res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=59')

  return {
    props: JSON.parse(
      JSON.stringify({
        canonical: `${origin}/voucher`,
        vouchers,
      })
    ),
  }
}
